import { render, staticRenderFns } from "./LeadFormTabs.vue?vue&type=template&id=eed592c0&scoped=true"
import script from "./LeadFormTabs.vue?vue&type=script&lang=js"
export * from "./LeadFormTabs.vue?vue&type=script&lang=js"
import style0 from "./LeadFormTabs.vue?vue&type=style&index=0&id=eed592c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.24_babel-core@6.26.3_cache-loader@4.1.0_webpack@5.10_ei55e3dlglycqw3km3vwexq5ke/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed592c0",
  null
  
)

export default component.exports